import React, { memo } from 'react';

import { Stack } from '@mui/material';
import PropTypes from 'prop-types';

import { getMergedShallowObjectsMemoized } from '../../LoanInfoModal.utils';

import { borderedFlexBoxStyles } from './BorderedFlexBox.styles';

const BorderedFlexBox = ({ customStyles, children }) => (
  <Stack sx={getMergedShallowObjectsMemoized(borderedFlexBoxStyles, customStyles)}>
    {children}
  </Stack>
);

BorderedFlexBox.propTypes = {
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.object,
};

export default memo(BorderedFlexBox);
